import { Alert } from '@tempmee/react';
import history from '~/browserHistory';
import { routes } from '~/routes';
import { usePendingAchBannerVisible } from './usePendingAchBannerVisible';

interface IPendingAchVerificationBannerProps {
  containerStyle?: React.CSSProperties;
  dataCy?: string;
}

export const PendingAchVerificationBanner = ({
  containerStyle,
  dataCy = 'pending-ach-warning',
}: IPendingAchVerificationBannerProps) => {
  const isVisible = usePendingAchBannerVisible();

  if (!isVisible) {
    return null;
  }

  return (
    <Alert
      data-cy={dataCy}
      severity="warning"
      role="button"
      tabIndex={0}
      onClick={() => history.push(routes.paymentInformation)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          history.push(routes.paymentInformation);
        }
      }}
      style={{
        cursor: 'pointer',
        marginBottom: 0,
        ...containerStyle,
      }}
      description="Bank Account Pending. Confirm deposit now"
    />
  );
};
